export enum ToastType {
  Success,
  Warning,
  Error,
  Info,
}
